import React, { useMemo } from 'react';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { useParams } from 'umi';
import { FRAME_TYPE_MAP } from '@/pages/benchmark/_config/constant';
import { formatFilterValues } from '@/pages/benchmark/utils/utils';

export default function MetricDetailCardService(props: any) {
  const { style, className, config, children, filterVal, filterLoading, data, metricGroupList, ...resetProps } = props || {};
  const { api } = config || {};
  const { metric } = useParams<{ metric: string; }>();

  // data?.frameType依赖确保切换中英文的时候，不会触发请求
  const newData = useMemo(() => ({
    ...(data || {}),
    groupMetric: metricGroupList?.map((item: any) => item.metric) || []
  }), [metricGroupList, data?.frameType]);

  return (
    <div className={className} style={style}>
      {/* @ts-ignore */}
      <Service
        api={api}
        dataKey={"metricData"}
        trackData={['frameType', 'groupMetric']}
        data={newData}
        filterVal={filterVal}
        filterLoading={filterLoading}
        beforeRequest={(data) => {
          const { frameType, filterVal, groupMetric } = data;
          const params = {
            filters: {
              ...formatFilterValues(filterVal),
              // genre_list: [],     // 跟后端核对该参数传为空数组
            },
            frame_type: FRAME_TYPE_MAP[frameType],
            has_game_contributors: true,
            metrics: groupMetric?.length > 0 ? groupMetric : [metric]
          };
          return params;
        }}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            metricGroupList,
            ...resetProps
          }))}
      </Service>
    </div>
  );
}
